<template>
  <div class="flex items-center justify-between">
    <div class="flex items-center mr-5">
      <div class="mr-4">
        <div v-if="customIcon" class="custom-icon">
          <img :src="customIcon">
        </div>
        <feather-icon
          v-else
          :icon="icon"
          class="p-3 inline-flex rounded-lg"
          :style="{color: `${color}`, background: convertHex(color)}" />
      </div>
      <div class="truncate flex-1">
        <h4 class="mb-1 font-bold" v-html="title"></h4>
      </div>
    </div>
    <span class="font-bold text-right">{{ count || 'Нет данных' }}</span>
  </div>
</template>

<script>
export default {
  data () {
    return {
      backgroundOpacity: 15
    }
  },

  props: {
    icon: {
      type: String
    },
    title: {
      type: String
    },
    count: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    customIcon: {
      type: String
    }
  },

  methods: {
    convertHex (color) {
      color = color.replace('#', '')
      const r = parseInt(color.substring(0, 2), 16)
      const g = parseInt(color.substring(2, 4), 16)
      const b = parseInt(color.substring(4, 6), 16)
      return `rgba(${r}, ${g}, ${b}, ${this.backgroundOpacity / 100})`
    }
  }
}
</script>

<style lang="scss" scoped>
  .custom-icon {
    img {
      width: 45px;
    }
  }
</style>
